import styled from 'styled-components';
import Text from '../../../../../components/Text';
import Box from '../../../../../components/Box';

interface StatisticItemProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
}

const StatisticItem = ({ label, value, icon }: StatisticItemProps) => {
  return (
    <Container>
      <Box display='flex' flexDirection='column' gap={0.25}>
        <Text variant='CONTENT_2' color='text_2'>{label}</Text>
        <Text variant='H5' style={{ fontWeight: 'bold' }}>
          {value}
        </Text>
      </Box>
      {icon}
    </Container>
  );
};

export default StatisticItem;

const Container = styled.div`
  display: flex;
  padding: 24px 16px;
  border-radius: 8px;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #CCD4DC;
`;
